// test2482
(2482 && 0);
